type AnyRecord = Record<string, unknown>;

const isPlainObject = (value: unknown): value is AnyRecord =>
    typeof value === 'object' && value !== null && !Array.isArray(value);

export const hasDiff = <T>(currentObject: Partial<T> | undefined, nextObject: Partial<T>): boolean => {
    for (const [key, nextValue] of Object.entries(nextObject)) {
        if (typeof nextValue === 'undefined') {
            continue;
        }

        const currentValue = currentObject?.[key as keyof T];

        if (isPlainObject(nextValue) && isPlainObject(currentValue)) {
            if (hasDiff(currentValue, nextValue)) {
                return true;
            }
            continue;
        }

        if (nextValue !== currentValue) {
            return true;
        }
    }

    return false;
};
